import { CATALOG, type ComponentEntry } from '@center-platform/component-catalog';
import type { A2uiComponentEntry } from 'types/space';

/** The `space`-surface slice of the catalog — the same filter `SpaceRendererOrganism` applies, centralized so Try mode's classification and the canvas's `inspect` resolution never drift apart. */
export const SPACE_CATALOG_ENTRIES: ComponentEntry[] = CATALOG.filter((entry) => entry.surfaces.includes('space'));

/**
 * A fired action is "write-shaped" (SC5) when its source component's catalog entry is in the
 * `domain` category — `SphereTypeSelector`, `UrgencySelector`, `SphereEditor` and siblings
 * (`sphereDomainAdapters.tsx`), the only adapters whose emitted actions represent a sphere-data
 * mutation rather than a generic UI interaction. `interactive`/`display`/`layout`/`organism`
 * category actions (Button, TextField, ContextShell…) are domain-agnostic: the document author
 * decides what they mean, and today nothing in the platform wires them to a mutation client
 * (`SpaceHost.tsx`'s `onAction` only ever routes to `useSpaceWires`/the legacy event bridge).
 * No adapter or `CompositionHost` invokes a mutation client in ANY mode (`types.ts`); this
 * classification drives Try mode's action-log DISPLAY, not the actual write prevention, which is
 * already structural.
 */
export function isWriteShapedAction(componentType: string, catalogEntries: ComponentEntry[]): boolean {
  return catalogEntries.some((entry) => entry.type === componentType && entry.category === 'domain');
}

/** Resolves the catalog entry for the component that fired `componentId`, for classification. */
export function findSourceCatalogEntry(
  componentId: string,
  components: A2uiComponentEntry[],
  catalogEntries: ComponentEntry[]
): ComponentEntry | undefined {
  const source = components.find((c) => c.id === componentId);
  if (!source) return undefined;
  return catalogEntries.find((entry) => entry.type === source.component);
}
